import api from '../utils/api';

class SeatMapApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/seat-map', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getAllFromOperator = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/pos/seat-map', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getSeatLock = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/v1/booking/busyseat/${id}`, {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getBusySeat = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/v1/booking/busyseat/${id}`, {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getSeatBooked = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(
          `/v1/company/booking/bookedseat/route/${id}`,
          {
            params: data,
          },
        );
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getBusySeatRoute = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/v1/company/booking/busyseat/${id}`, {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/seat-map', data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/seat-map/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/seat-map/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  copy = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/seat-map/copy/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const seatMapApi = new SeatMapApi();
export default seatMapApi;
